import { render, staticRenderFns } from "./CaptionParser.vue?vue&type=template&id=63a54f3c&scoped=true&"
import script from "./CaptionParser.vue?vue&type=script&lang=js&"
export * from "./CaptionParser.vue?vue&type=script&lang=js&"
import style0 from "./CaptionParser.vue?vue&type=style&index=0&id=63a54f3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a54f3c",
  null
  
)

export default component.exports